import { REQUEST_STATUSES } from "@/constants";
import { getErrorResponse } from "@/utils/helper";

import { api } from "./instance";

export class ExperienceMediaItemService {
  static async getExperienceMediaItems(propertyId, experienceId, query) {
    try {
      const resp = await api({
        method: "get",
        url: `/api/v2/experience-media-items/${propertyId}/${experienceId}`,
        params: query,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: { data: [], count: 0 },
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async addExperienceMediaItem(propertyId, experienceId, mediaItemId) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/experience-media-items/${propertyId}/${experienceId}/${mediaItemId}`,
        data: {},
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async deleteExperienceMediaItem(propertyId, experienceId, mediaItemId) {
    try {
      const resp = await api({
        method: "delete",
        url: `/api/v2/experience-media-items/${propertyId}/${experienceId}/${mediaItemId}`,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async bulkAddExperienceMediaItem(propertyId, experienceId, data) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/experience-media-items/bulk/add/${propertyId}/${experienceId}`,
        data,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async bulkDeleteExperienceMediaItem(propertyId, experienceId, data) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/experience-media-items/bulk/delete/${propertyId}/${experienceId}`,
        data,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }
}
